export default {
    SET_NETWORK_STATE: 'SET_NETWORK_STATE',
    SET_SCREEN_ORIENTATION: 'SET_SCREEN_ORIENTATION'
};
